<template>
  <section class="ds s-py-45 s-py-xl-75 c-gutter-60">
    <div class="container">
      <div class="row">
        <main class="col-lg-12">
          <article>
            <div class="entry-content">
              <div class="woocommerce">
                <div class="woocommerce-MyAccount-content">
                  <!-- <div style="padding: 4px;border: 2px solid green;text-align: center;"> Updated Client</div> -->
                  <div>
                    <Toast ref="toast" />
                  </div>
                  <form id="child-form" role="form" style="display: block">
                    <p class="mm-font __mm" align="center">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>
                    <br />
                    <br />
                    <label class="form-group">
                      <span class="mm-font __mm __mm">အမည်</span>
                      <input
                        type="text"
                        class="form-control"
                        required
                        v-model="offer.name"
                        name="name"
                      />
                      <span
                        class="error__message"
                        v-if="!offer.name && errors.name"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ errors.name }}
                      </span>
                    </label>
                    <label class="form-group">
                      <span class="mm-font __mm">မွေးသက္ကရာဇ်</span>

                      <md-datepicker
                        :md-disabled-dates="disablePastDates"
                        v-model="offer.birthday"
                        name="birthday"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        required
                        ref="datepicker"
                      >
                        <label class="date__picker" v-if="!offer.birthday"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                      <div
                        class="error__message"
                        v-if="!offer.birthday && errors.birthday"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.birthday }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေ့နံ</span>
                      <div class="dropdown__container">
                        <select
                          class="mm-font __mm"
                          v-model="offer.birth_day"
                          name="birth_day"
                          required
                        >
                          <option value="" class="__mm" selected>
                            နေ့နံရွေးချယ်ပါ
                          </option>
                          <option value="တနင်္ဂနွေ" class="__mm">
                            တနင်္ဂနွေ
                          </option>
                          <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                          <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                          <option value="ဗုဒ္ဓဟူး" class="__mm">
                            ဗုဒ္ဓဟူး
                          </option>
                          <option value="ရာဟု" class="__mm">ရာဟု</option>
                          <option value="ကြာသပတေး" class="__mm">
                            ကြာသပတေး
                          </option>
                          <option value="သောကြာ" class="__mm">သောကြာ</option>
                          <option value="စနေ" class="__mm">စနေ</option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <span
                        class="error__message"
                        v-if="!offer.birth_day && errors.birth_day"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ errors.birth_day }}
                      </span>
                    </label>
                    <input
                      type="radio"
                      value="Yes"
                      required
                      name="martial_status"
                      v-model="offer.martial_status"
                    />
                    <span for class="mm-font __mm" style="margin-right: 20px"
                      >အိမ်ထောင်ရှိ</span
                    >
                    <input
                      type="radio"
                      value="No"
                      required
                      name="martial_status"
                      v-model="offer.martial_status"
                    />
                    <span for class="mm-font __mm">အိမ်ထောင်မရှိ</span>
                    <div
                      class="error__message"
                      v-if="!offer.martial_status && errors.martial_status"
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      {{ errors.martial_status }}
                    </div>
                    <br /><br />
                    <label class="form-group">
                      <span for class="mm-font __mm">အလုပ်အကိုင်</span>
                      <div
                        style="
                          display: grid;
                          grid-template-rows: 1fr 1fr;
                          gap: 5px;
                        "
                      >
                        <div class="dropdown__container">
                          <select
                            name="job"
                            class="mm-font __mm"
                            v-model="offer.job"
                            required
                          >
                            <option value="" selected hidden>
                              အလုပ်အကိုင် အမျိုးအစား
                            </option>
                            <option value="အစိုးရဝန်ထမ်း">အစိုးရဝန်ထမ်း</option>
                            <option value="ကုမ္ပဏီဝန်ထမ်း">
                              ကုမ္ပဏီဝန်ထမ်း
                            </option>
                            <option value="ကိုယ်ပိုင်စီးပွားရေး">
                              ကိုယ်ပိုင်စီးပွားရေး
                            </option>
                            <option value="ကျောင်းသား/သူ">ကျောင်းသား/သူ</option>
                            <option value="အခြား">အခြား</option>
                          </select>
                          <i class="pi pi-chevron-down dropdown__icon"></i>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          name="job_detail"
                          v-model="offer.job_detail"
                          placeholder="အလုပ်ကိုင်အသေးစိတ် "
                        />
                        <div
                          class="error__message"
                          v-if="(!offer.job || !offer.job_detail) && errors.job"
                        >
                          <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                          {{ errors.job }}
                        </div>
                      </div>
                    </label>
                    <input
                      type="radio"
                      value="Male"
                      v-model="offer.gender"
                      name="gender"
                      required
                    />
                    <span for class="mm-font __mm" style="margin-right: 20px"
                      >ကျား</span
                    >
                    <input
                      type="radio"
                      value="Female"
                      v-model="offer.gender"
                      name="gender"
                      required
                    />
                    <span for class="mm-font __mm">မ</span>
                    <div
                      class="error__message"
                      v-if="!offer.gender && errors.gender"
                    >
                      <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                      {{ errors.gender }}
                    </div>
                    <br /><br />
                    <label class="form-group">
                      <span for="" class="mm-font">
                        Viber အသုံးပြုသော ဖုန်းနံပါတ်အားထည့်ပါ</span
                      >
                      <input
                        type="number"
                        class="form-control"
                        v-model="offer.viber_no"
                        name="viber_no"
                        placeholder="09xxxxxxxxx"
                        @input="validateForm"
                        required
                      />
                      <div class="error__message" v-if="errors.viber_no">
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.viber_no }}
                      </div>
                    </label>
                    <label class="form-group">
                      <span for class="mm-font __mm">နေရပ်လိပ်စာ</span>
                      <div class="dropdown__container">
                        <select
                          v-model="offer.address_division"
                          required
                          class="mm-font __mm"
                          @change="handleDivisionChange"
                        >
                          <option value="" selected hidden>
                            ပြည်နယ်/တိုင်း
                          </option>
                          <option
                            v-for="d in divisions"
                            :data-nrc="d.nrc_id"
                            :value="d.name"
                            :key="d.name"
                            class="__mm"
                          >
                            {{ d.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <div class="dropdown__container">
                        <select
                          v-model="offer.address_township"
                          required
                          class="mm-font __mm"
                        >
                          <option value="" selected hidden>မြို့နယ်</option>
                          <option
                            value=""
                            disabled
                            v-if="townships.length == 0"
                          >
                            တိုင်း/ ပြည်နယ် ကိုအရင်ရွေးချယ်ပါ
                          </option>
                          <option
                            v-for="t in townships"
                            :value="t.name"
                            :key="t.name"
                            class="__mm"
                          >
                            {{ t.name }}
                          </option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <input
                        type="text"
                        class="mm-font __mm form-control"
                        placeholder="ရပ်ကွက်/လမ်း အသေးစိတ်"
                        v-model="offer.address"
                        required
                      />
                      <div
                        class="error__message"
                        v-if="
                          (!offer.address ||
                            !this.offer.address_division ||
                            !this.offer.address_township) &&
                          errors.address
                        "
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.address }}
                      </div>
                    </label>
                    <!-- <label class="form-group">
                      <span for class="mm-font__mm"
                        >မေးမြန်းလိုသည့်မေးခွန်းအရေအတွက်</span
                      >
                      <div>
                        <input
                          type="radio"
                          value="2"
                          v-model="offer.q_quantity"
                          name="q_quantity"
                        />
                        <span style="margin-right: 20px">၂ခု</span>
                        <input
                          type="radio"
                          value="4"
                          v-model="offer.q_quantity"
                          name="q_quantity"
                        />
                        <span>၄ခု</span>
                        <div class="error__message" v-if="!offer.q_quantity && errors.q_quantity">
                          <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                          {{ errors.q_quantity }}
                        </div>
                      </div>
                    </label> -->
                    <p class="mm-font">မိမိသိလိုသော ကြောင်းအရာ</p>
                    <label class="form-group">
                      <textarea
                        v-model="offer.about"
                        name="about"
                        class="mm-font test"
                        rows="10"
                        cols="35"
                        style="color: black"
                        required
                      ></textarea>
                      <div
                        class="error__message"
                        v-if="!offer.about && errors.about"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.about }}
                      </div>
                    </label>

                    <p class="t_c_agreement">
                      By continuing, you agree to
                      <span @click.prevent="redirectTNC()"
                        >Terms and Conditions.</span
                      >
                    </p>

                    <p>ဉာဏ်ပူဇော်ခ ၁၀၀၀၀ ကျပ် ကျသင့်ပါမည်။</p>
                    <p>
                      <input
                        @click.prevent="handleSubmit()"
                        type="submit"
                        :disabled="disabled"
                        class="woocommerce-Button button mm-font __mm"
                        value="အတည်ပြုမည်"
                      />
                    </p>
                  </form>
                  <br />
                  <div>
                    <div class="col-md-12">
                      <p class="mm-font __mm cat">
                        ဟောစာတမ်းများကို ၃ ရက်အတွင်း
                        ပြန်လည်ပေးပို့ပါမည်
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  </section>
</template>

<script>
import { checkFormModel, getFormData } from "@core/lib/form-data";
import { Horo, HTTP } from "../../core/lib/http-common";
import { mapGetters } from "vuex";
import { citizenPay, makePayment, onePay } from "../js/payment";
import { getDivisions, getTownships } from "../js/addressInfo";
import { EventBus } from "../../public/js/eventBus";
import { validatePhoneNumber } from "../utils/validationPhone";
import Toast from "../UI/Toast.vue";
export default {
  name: "Offer",
  components: { Toast },

  data() {
    return {
      datepicker: null,
      divisions: [],
      townships: [],
      actionBtnMethod: "",
      disabled: false,
      onepayPhoneNumber: "",
      offer: {
        name: "",
        birthday: "",
        birth_day: "",
        martial_status: "",
        job: "",
        job_detail: "",
        gender: "",
        viber_no: "",
        address: "",
        address_division: "",
        address_township: "",
        about: "",
        // q_quantity: "",
        price: "",
        user_id: "0",
        order_id: "0",
      },
      errors: {},
      isMM: false,
    };
  },
  async created() {
    this.divisions = await getDivisions();
    this.actionBtnMethod = this.$store.state.paymentName;
  },
  mounted() {
        console.log("Config: special offer", this.$configService.config);
        console.log("Config: special offer Config value ", this.$configService.getConfigValue('Specialoffer'));

    this.onepayPhoneNumber =
      this.$store.state.paymentName == "onepay"
        ? this.$store.state.onepayPhoneNumber
        : "";

    if (this.$refs.datepicker) {
      const input = this.$refs.datepicker.$el.querySelector("input");
      if (input) {
        input.setAttribute("readonly", "true");
      }
    }

    this.getLocale();
  },
  computed: {
    ...mapGetters({
      getUserToken: "userStore/getUserToken",
      getResponse: "userStore/getResponse",
    }),

    price: {
      get() {
        // return this.offer.q_quantity == "2"
        //   ? 7000
        //   : this.offer.q_quantity == "4"
        //   ? 12000
        //   : 7000;
        return 7000;
      },
    },

    disablePastDates() {
      const today = new Date();
      return (date) => new Date(date) >= today;
    },
  },
  methods: {
    showToast(text) {
      // this.$refs.toast.show(`This is ${text} toast!`);
      console.log('text', text);
      
    },
    getLocale() {
      window.ma.callNativeAPI("getLocale", {}, (res) => {
        this.isMM = res.language === "my-MM";
      });
    },

    async handleDivisionChange(e) {
      let nrc_id = e.target.options[e.target.selectedIndex].dataset.nrc;
      this.townships = await getTownships(nrc_id);
    },

    redirectTNC() {
      this.$router.push("/category/terms_and_conditions");
    },

    handleSubmit() {
      this.validateForm();
      if (Object.values(this.errors).some((v) => v)) return;
      this.paymentProvider();
    },
    handleQuantityChange() {},
    paymentProvider() {
      let getPaymentName = this.actionBtnMethod;
      console.log("getPaymentName", getPaymentName);
      // this.showToast(`${getPaymentName} getPaymentName`);
      switch (getPaymentName) {
        case "mpitesan":
          this.makePayment();
          break;
        case "onepay":
          this.onePayProvider();
          break;
        case "citizenpay":
          this.citizenPayProvider();
          break;
        case "bppay":
          this.bpPay();
          break;
        default:
          this.precreate();
          break;
      }
    },

    precreate() {
      console.log("this.price", this.price);

      this.offer.price = this.price; // this must be set at very first
      // checkFormModel => converts a JS object into FormData (for file uploads or API requests).
      if (checkFormModel(this.offer)) {
        this.disabled = true; // disable button after form validation success
        console.log("this.getUserToken ==> ", this.getUserToken);
        // this.showToast(`${this.getUserToken} getUserToken`);
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: 3480,
          amount: this.offer.price,
          // quantity: this.offer.q_quantity,
          category_name: "specialoffer",
          name: this.offer.name,
        })
          .then((response) => {
            console.log('1875 Backend Api Call Response', response );

            const res = response.data;
            this.offer.user_id = res.user_id;
            this.offer.order_id = res.order_id;
            let form_data = getFormData(this.offer);
            form_data.set("price", res.amount);
            form_data.append(
              "user_phone",
              this.getResponse.customer_info.msisdn
            );
            form_data.append("payment_method", "KBZPay");
            form_data.append("srcFrom", "KBZPay");
            console.log("KBZ Pay");
            // this.showToast("KBZ Pay");
            Horo.post("1875/specialoffer/horoscope", form_data).then(
              (response) => {
                this.res_status = response.data.status;
                console.log('horoscope response', response );
                
            this.showToast("horoscope ", response.data);

                // new kbzpay mini_app api
                window.ma.callNativeAPI(
                  "startPay",
                  {
                    prepayId: res.prepay_id,
                    orderInfo: res.order_info,
                    sign: res.sign_app,
                    signType: "SHA256",
                    disableNewCheckout: "false",
                    tradeType: "MINIAPP",
                  },
                  (res) => {
            this.showToast("startPay ", res);

                    console.log("startPay api res: ", res);
                    if (res.resultCode == 1) {
                      EventBus.$emit("clear-cache");
                      console.log("startpaysucess");
                      if (!this.isMM) {
                        this.$swal(
                          "Success",
                          "Purchased. Please contact 09456880335 if you have any problems.",
                          "success"
                        );
                        this.$router.push({ name: "home" });
                      }
                      if (this.isMM) {
                        this.$swal(
                          "အောင်မြင်ပါသည်",
                          "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                          "success"
                        );
                        this.$router.push({ name: "home" });
                      }
                    } else {
                      if (!this.isMM) {
                        this.$swal("Fail", "Please try again", "error");
                        this.disabled = false;
                      }
                      if (this.isMM) {
                        this.$swal(
                          "မအောင်မြင်ပါ",
                          "ထပ်မံကြိုးစားပေးပါ",
                          "error"
                        );
                        this.disabled = false;
                      }
                    }
                  }
                );
                // this.kbzpay.startPay(
                //   res.prepay_id,
                //   res.order_info,
                //   res.sign_app,
                //   ({ resultCode, lang }) => {
                //     if (resultCode == 1) {
                //       if (lang == "en") {
                //         this.$swal("Success", "Your Purchase Success", "success");
                //         this.$router.push({ name: "home" });
                //       }
                //       if (lang == "my") {
                //         this.$swal("အောင်မြင်ပါသည်", "ဝယ်ယူပြီးပါပြီ", "success");
                //         this.$router.push({ name: "home" });
                //       }
                //     }
                //     if (resultCode == 2) {
                //       if (lang == "en") {
                //         this.$swal("Failed", "Your Purchase Failed", "error");
                //         this.disabled = false;
                //       }
                //       if (lang == "my") {
                //         this.$swal("မအောင်မြင်ပါ", "ထပ်မံကြိုးစားပေးပါ", "error");
                //         this.disabled = false;
                //       }
                //     }
                //   },
                //   () => {
                //     this.$swal("Failed", "Your Purchase Failed", "error");
                //     this.disabled = false;
                //   }
                // );
              }
            );
          })
          .catch((error) => {
                  this.showToast(`1875 Backend Api Call Response Error ${error}`);

            console.log('1875 Backend Api Call Response Error', error);
            this.message = "Something went wrong";
          });
      } else {
        if (this.isMM) {
          this.$swal(
            "Oops",
            "လိုအပ်သည့်အချက်အလက်များ အားလုံးဖြည့်ပေးပါ။",
            "error"
          );
        } else {
          this.$swal("Oops", "You need to fill all fields.", "error");
        }
      }
    },

    async bpPay() {
      this.offer.price = this.price;
      if (checkFormModel(this.offer)) {
        this.disabled = true;

        let form_data = getFormData(this.offer);
        form_data.append("user_phone", this.offer.viber_no);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        form_data.append("payment_method", payment_method);
        form_data.append("srcFrom", "PWA BPPay");

        let cdata = {
          category_id: 3480,
          amount: this.offer.price,
          category_name: "specialoffer",
          // quantity: this.offer.q_quantity,
          phone_number: this.offer.viber_no,
          payment_name: this.actionBtnMethod,
        };
        console.log("bpPay");
        this.showToast("bpPay");
        // alert("bpPay");
        await makePayment([
          "1875/specialoffer/horoscope",
          form_data,
          cdata,
          this.$store.state.backendUrl,
          this.offer.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "bppay" },
                });
              }
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async makePayment() {
      this.offer.price = this.price; // this must be set at very first
      if (checkFormModel(this.offer)) {
        this.disabled = true;

        let form_data = getFormData(this.offer);
        form_data.append("user_phone", this.offer.viber_no);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        form_data.append("payment_method", payment_method);
        form_data.append("srcFrom", "MPitesan");
        let cdata = {
          category_id: 3480,
          // quantity: this.offer.q_quantity,
          amount: this.offer.price,
          category_name: "specialoffer",
          // promocode: this.promocode,
          phone_number: this.offer.viber_no,
          payment_name: this.actionBtnMethod,
        };
        console.log("MPitesan");
        this.showToast("MPitesan");
        // alert("MPitesan");
        await makePayment([
          "1875/specialoffer/horoscope",
          form_data,
          cdata,
          this.$store.state.backendUrl,
          this.offer.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              // console.log(data);
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async onePayProvider() {
      this.offer.price = this.price; // this must be set at very first
      if (checkFormModel(this.offer)) {
        this.offer.user_id = this.onepayPhoneNumber;
        this.disabled = true;

        let form_data = getFormData(this.offer);
        form_data.append("user_phone", this.offer.viber_no);
        form_data.append("srcFrom", "OnePay");
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        form_data.append("payment_method", payment_method);
        let cdata = {
          category_id: 3480,
          // quantity: this.offer.q_quantity,
          amount: this.offer.price,
          category_name: "specialoffer",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.direct.phone_number
              : this.onepayPhoneNumber,
        };
        console.log("OnePay");
        // alert("OnePay");
        this.showToast("OnePay");
        await onePay([
          "1875/specialoffer/horoscope",
          form_data,
          cdata,
          this.$store.state.backendUrl,
          this.offer.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async citizenPayProvider() {
      this.offer.price = this.price;
      if (checkFormModel(this.offer)) {
        this.disabled = true;
        let form_data = getFormData(this.offer);
        form_data.append("user_phone", this.offer.viber_no);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        form_data.append("payment_method", payment_method);
        form_data.append("srcFrom", "Citizen Pay");

        let cdata = {
          category_id: 3480,
          // quantity: this.offer.q_quantity,
          amount: this.offer.price,
          category_name: "specialoffer",
        };
        console.log("Citizen Pay");
        this.showToast("Citizen Pay");
        // alert("Citizen Pay");
        await citizenPay([
          "1875/specialoffer/horoscope",
          form_data,
          cdata,
          this.$store.state.backendUrl,
          this.offer.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    validateForm() {
      this.errors = {};

      if (this.offer.name === "" || !this.offer.name)
        this.errors.name = "အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.offer.birthday === "" || !this.offer.birthday)
        this.errors.birthday = "မွေးသက္ကရာဇ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.offer.birth_day === "" || !this.offer.birth_day)
        this.errors.birth_day = "နေ့နံရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (this.offer.martial_status === "" || !this.offer.martial_status)
        this.errors.martial_status =
          "အိမ်ထောင်ရှိ/မရှိ ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.offer.job === "" ||
        !this.offer.job ||
        this.offer.job_detail === "" ||
        !this.offer.job_detail
      )
        this.errors.job = "အလုပ်အကိုင်အမျိုးအစားရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (this.offer.gender === "" || !this.offer.gender)
        this.errors.gender = "ကျား/မ ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.offer.address_division === "" ||
        !this.offer.address_division ||
        this.offer.address_township === "" ||
        !this.offer.address_township ||
        this.offer.address === "" ||
        !this.offer.address
      )
        this.errors.address = "နေရပ်လိပ်စာထည့်ရန်လိုအပ်ပါသည်။";
      // if(!this.offer.q_quantity || this.offer.q_quantity === '') this.errors.q_quantity = "မေးခွန်းအရေအတွက်ရွေးချယ်ရန်လိုအပ်ပါသည်။"
      if (!this.offer.about || this.offer.about === "")
        this.errors.about = "သိလိုသောအကြောင်းအရာထည့်ရန်လိုအပ်ပါသည်။";
      this.errors.viber_no = validatePhoneNumber(this.offer.viber_no);
    },
  },
};
</script>

<style>
input {
  background-color: red;
}

input[type="radio"] {
  display: inline !important;
  margin-right: 5px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input-container {
  display: flex;
  border: 1px solid #000;
  background-color: #f2eff7;
  color: #3e1e68;
  border-radius: 25px;
  align-items: center;
  padding: 0px 0px 0px 10px;
  margin: 0px !important;
}

.date__picker {
  margin-top: -8px !important;
  margin-left: 12px !important;
}

.md-field.md-theme-default:after {
  background-color: rgba(0, 0, 0, 0) !important;
}

.md-button.md-theme-default {
  margin: 0px 16px 5px 0px;
}

.md-field.input-container.md-theme-default.md-clearable.md-datepicker {
  padding-top: 0px;
}
</style>
